<main class="testcase">
  <section class="testcase__wrap">
    <!--    <form action="" class="testcase__form">-->
    <!--      <label for="apptrack" class="testcase__title"-->
    <!--        >Select your Test case of the old Apptrack</label-->
    <!--      >-->
    <!--      <select-->
    <!--        class="testcase__form-select"-->
    <!--        id="apptrack"-->
    <!--        (change)="sendTestcase($event, 'old')"-->
    <!--      >-->
    <!--        <ng-container *ngFor="let option of testData">-->
    <!--          <option [value]="option.value">{{ option.name }}</option>-->
    <!--        </ng-container>-->
    <!--      </select>-->
    <!--    </form>-->
    <form action="" class="testcase__form">
      <label for="apptrackNew" class="testcase__title"
        >Select your Test case of the new Apptrack</label
      >
      <select
        class="testcase__form-select"
        id="apptrackNew"
        (change)="sendTestcase($event, 'new')"
      >
        <ng-container *ngFor="let option of testData">
          <option [value]="option.value">{{ option.name }}</option>
        </ng-container>
      </select>
    </form>
  </section>
</main>
